import { IEntitySchemaDefinition } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

const Fieldset = ui.S9Fieldset.default;
const S9PageSection = ui.S9PageSection.default;

type Props = {
  schema: IEntitySchemaDefinition | undefined;
};
const AccountDetail = ({ schema }: Props) => {
  const fields = [
    {
      field: 'account_number',
      colSize: 12,
    },
    {
      field: 'default_country',
      colSize: 6,
    },
    {
      field: 'is_active',
      colSize: 6,
    },
  ];

  return (
    <S9PageSection title="Account details" size="sm">
      {schema && (
        <Fieldset
          context={{ id: undefined }}
          schema={schema}
          formFields={fields}
        />
      )}
    </S9PageSection>
  );
};

export default AccountDetail;
